
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  EmailAddressValidity,
  NewEmailForm,
  PhoneRequest,
} from '../models';
import {
    EmailAddressValidityFromJSON,
    EmailAddressValidityToJSON,
    NewEmailFormFromJSON,
    NewEmailFormToJSON,
    PhoneRequestFromJSON,
    PhoneRequestToJSON,
} from '../models';

export interface ChangePhoneNumberRequest {
    phoneRequest: PhoneRequest;
}

export interface GetEmailAddressValidityRequest {
    email: string;
}

export interface InitChangeEmailRequest {
    newEmailForm: NewEmailForm;
}

export interface ValidateEmailRequest {
    code: string;
}

/**
 * 
 */
export class AccountSettingsApi extends runtime.BaseAPI {

    /**
          */
    async changePhoneNumberRaw(requestParameters: ChangePhoneNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['phoneRequest'] == null) {
            throw new runtime.RequiredError(
                'phoneRequest',
                'Required parameter "phoneRequest" was null or undefined when calling changePhoneNumber().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/phone`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PhoneRequestToJSON(requestParameters['phoneRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async changePhoneNumber(phoneRequest: PhoneRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.changePhoneNumberRaw({ phoneRequest: phoneRequest }, initOverrides);
    }

    /**
     * Ask whether an email address can be used
          */
    async getEmailAddressValidityRaw(requestParameters: GetEmailAddressValidityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<EmailAddressValidity>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getEmailAddressValidity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<EmailAddressValidity>({
            path: `/client-settings/api/email/validity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=EmailAddressValidityFromJSON(response._data); }
        return response;
    }

    /**
     * Ask whether an email address can be used
          */
    async getEmailAddressValidity(email: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<EmailAddressValidity> {
        const response = await this.getEmailAddressValidityRaw({ email: email }, initOverrides);
        return response._data;
    }

    /**
     * Initialize a change email, that will be handled once the code send by mail is enter
          */
    async initChangeEmailRaw(requestParameters: InitChangeEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['newEmailForm'] == null) {
            throw new runtime.RequiredError(
                'newEmailForm',
                'Required parameter "newEmailForm" was null or undefined when calling initChangeEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/changeEmail`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewEmailFormToJSON(requestParameters['newEmailForm']),
        }, initOverrides);

        return response;
    }

    /**
     * Initialize a change email, that will be handled once the code send by mail is enter
          */
    async initChangeEmail(newEmailForm: NewEmailForm, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.initChangeEmailRaw({ newEmailForm: newEmailForm }, initOverrides);
    }

    /**
     * Send a new code for email validation
          */
    async resendEmailValidationCodeRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/api/send-email-validation-code`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Send a new code for email validation
          */
    async resendEmailValidationCode(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.resendEmailValidationCodeRaw(initOverrides);
    }

    /**
     * Validate an email by code
          */
    async validateEmailRaw(requestParameters: ValidateEmailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling validateEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/api/validate-email/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Validate an email by code
          */
    async validateEmail(code: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.validateEmailRaw({ code: code }, initOverrides);
    }

}
